export default {
    categoryGroups:         { method: 'get',    url: 'category_groups' },
    createCategoryGroup:    { method: 'post',   url: 'category_groups'},
    updateCategoryGroup:    { method: 'put',    url: 'category_groups/{id}'},
    deleteCategoryGroup:    { method: 'delete', url: 'category_groups/{id}'}
}